import { Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { Router, RouterModule } from '@angular/router';

@Component({
  selector: 'ui-sidenav-item',
  imports: [
    MatButtonModule, RouterModule
  ],
  templateUrl: './sidenav-item.html',
  styleUrl: './sidenav-item.scss'
})
export class SidenavItem {
  @Input() menuItem: any;
  @Input() onClickEvent: () => {};
  @Input() badgeCount?: any;

  constructor(private router: Router) { }

  getIconClasses(): string {
    const variant = this.menuItem?.iconVariant?.trim();
    const icon = this.menuItem?.icon?.trim();

    if (!variant || !icon) {
      return '';
    }

    const variantClass = variant.startsWith('fa-') ? variant : `fa-${variant}`;
    const iconClass = icon.startsWith('fa-') ? icon : `fa-${icon}`;

    return `${variantClass} ${iconClass}`;
  }

  // Metodo usato per tenere selezionata la voce nel menu laterale 
  // quando si naviga ad una sezione figlia
  getIsActive(): boolean {
    // Pulisco l'url da parametri e frammenti
    let currentUrl = this.router.url.split('?')[0].split('#')[0];
    let targetPath = this.menuItem.path;

    // Normalizzo entrambe in modo che inizino con lo slash
    if (!currentUrl.startsWith('/')) currentUrl = '/' + currentUrl;
    if (!targetPath.startsWith('/')) targetPath = '/' + targetPath;
    
    // Se sono indentiche ritorno true
    if (currentUrl === targetPath) return true;

    // Estraggo il primo segmento dell'url che non sia vuoto
    const getFirstSegment = (path: string) => path.split('/').filter(s => s !== '')[0];

    const currentRoot = getFirstSegment(currentUrl);
    const targetRoot = getFirstSegment(targetPath);

    // Confronto e controllo per capire se sono un figlio della rotta
    if (currentRoot && targetRoot && (currentRoot === targetRoot)) {
      return true;
    }
    return false;
  }
}
